const productData = [
  {
    id: 1,
    name: "Red Berry Voyage",
    category: "Teas",
    price: "10.10",
    reviews: "342",
    rating: "4.8",
    image: "/img/101.jpg",
    images: ["/img/101.jpg", "/img/101a.webp", "/img/101b.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "China organic black tea",
    description: [
      "A balanced black tea with layers of red berries, soft florals, and honeyed depth. Red Berry Voyage is an inviting choice for both seasoned tea drinkers and curious newcomers.",
      "Also available in Tins and Teabags",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Black+ | Strawberry, lotus floral, and honey notes; refreshing mouthfeel.",
      "Tea Tips: If you're uncertain about which tea to serve at a gathering, this one is an excellent choice! It tastes great whether you add milk and sugar or enjoy it plain.",
      "Ingredients: China organic black tea, red fruit, and floral organic flavorings",
      "How to Steep: 1 tsp, 8 oz water, 212°F, 4–5 min",
      "Fun Fact: Fruit and flower aromatics have been paired with black tea for generations to create a fragrant, rounded cup.",
      "Similar Teas: French Breakfast Tea, Paris Morning Tea",
      "Our organic ingredients are selected from suppliers that document origin, handling, and applicable purity standards.",
    ],
  },
  {
    id: 2,
    name: "French Breakfast Tea",
    category: "Teas",
    price: "11.45",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp", "/img/102a.webp", "/img/102b.webp", "/img/102c.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "China organic and India-Darjeeling organic black tea blend",
    description: [
      "This rich and creamy black tea blend has hints of vanilla and offers a complex and distinctive flavor. French Breakfast is delicious both with and without milk.",
      "Also available in Teabags",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Black | malt, dark cocoa, sweet vanilla notes.",
      "Tea Tips: French Breakfast is one of our most popular breakfast teas. It is delicious for breakfast, afternoon tea, or dessert.",
      "Ingredients: China organic and India-Darjeeling organic black tea blend",
      "How to Steep: 1 tsp, 8 oz water, 208°F, 4–5 min",
      "Fun Fact: For a French breakfast, serve this tea with a croissant or macaron.",
      "Similar Teas: Classic English Breakfast, Paris Morning Tea, Irish Breakfast",
      "Our organic ingredients are selected from suppliers that document origin, handling, and applicable purity standards.",
    ],
  },
  {
    id: 3,
    name: "Blue Bergamot Earl Grey",
    category: "Teas",
    price: "10.70",
    reviews: "214",
    rating: "4.7",
    image: "/img/103.webp",
    images: ["/img/103.webp", "/img/103a.webp", "/img/103b.webp", "/img/103c.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "Sri Lanka organic black tea",
    description: [
      "Our Earl Grey tea combines the citrus and floral notes of high-quality bergamot oil with premium black tea sourced from high elevations in Sri Lanka.",
      "It is also available in Tins and Teabags.",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Black+ | citrus, floral, balanced, refreshing",
      "Tea Tips: For the Earl Grey lover. Pair with chocolate, cream desserts, or pastries.",
      "Ingredients: Sri Lanka organic black tea, organic cornflower petals, organic flavoring.",
      "How to Steep: 1 tsp, 8 oz water, 212°F, 4–5 min",
      "Fun Fact: The term 'bergamot' comes from the Italian 'bergamotto,' meaning 'lord's pear,' due to its shape. Calabria, Italy, produces 90% of the world's bergamot. Earl Grey, the most famous flavored black tea, was created as a gift for Charles Grey, the 2nd Earl Grey and UK Prime Minister from 1830 to 1834.",
      "Similar Teas: Vanilla Cream Earl Grey, Classic Earl Grey, Citrus Black Tea",
      "Our organic ingredients are selected from suppliers that document origin, handling, and applicable purity standards.",
    ],
  },
  {
    id: 4,
    name: "Kukicha",
    category: "Teas",
    price: "11.45",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp", "/img/104a.webp", "/img/104b.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "Japan, Kyushu Yabukita green tea and leaf stems",
    description: [
      "Kukicha is a surprising tea that delights even those skeptical of Japanese green teas. It has both savory and sweet flavors!",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Green Tea & Stems | fresh greens, edamame, sweet snap peas, subtle tropical fruit note, lingering, brothy mouthfeel.",
      "Tea Tips: Tea leaf stems contain 0% caffeine and constitute 50% of this tea. The L-theanine in green tea promotes calmness and focus, whether day or night.",
      "Ingredients: Japan, Kyushu Yabukita green tea and leaf stems",
      "How to Steep: 1.5–2 tsp, 8 oz water, 155°F, 1–1.5 min (steep multiple times)",
      "Fun Fact: Kukicha and sencha are both produced from the Yabukita tea cultivar. Kukicha translates to 'stem tea.'",
      "Similar Teas: Hand-Plucked Sencha, Shade-Grown Sencha",
    ],
  },
  {
    id: 5,
    name: "Wedding Caramel",
    category: "Teas",
    price: "10.10",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp", "/img/105a.webp", "/img/105b.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "India Assam organic black tea",
    description: [
      "A romantic blend of organic black tea, chocolate, and caramel. One sip and you'll fall in love.",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Black+ | cocoa, caramel, bold and lively flavor",
      "Tea Tips: As an afternoon treat, enjoy with or without milk and sugar. Pair with cream-based desserts.",
      "Ingredients: India Assam organic black tea, dark chocolate and dark caramel flavorings",
      "How to Steep: 1 tsp, 8 oz water, 212°F, 4–5 min",
      "Fun Fact: This tea pairs equally well with a bride's vanilla cake and the groom's chocolate cake.",
      "Similar Teas: Vanilla Cream Earl Grey, Madagascar Vanilla, Dark Chocolate Tea",
      "Our organic ingredients are selected from suppliers that document origin, handling, and applicable purity standards.",
    ],
  },
  {
    id: 6,
    name: "Ayurvedic Calm",
    category: "Tisanes",
    price: "6.10",
    reviews: "198",
    rating: "4.5",
    image: "/img/106.webp",
    images: ["/img/106.webp", "/img/106a.webp", "/img/106b.webp", "/img/106c.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "Cinnamon, licorice root, ginger, fennel, orange peel, cardamom",
    description: [
      "A calming, sweet, refreshing, and caffeine-free blend of sweet herbs and spices.",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Tisane+ | spicy, sweet, lingering mouth-feel",
      "Tisane Tips: Caffeine-free, soothing, spice turns to sweet without the calories.",
      "Ingredients: Cinnamon, licorice root, ginger, fennel, orange peel, cardamom",
      "How to Steep: 1.5 tsp, 8 oz water, 212°F, 6–8 min",
      "Fun Fact: Ayurveda is the practice of using spices and herbs as medicine",
      "Similar Tisanes: Baked Apple Almond, Brewed Calm, Orange Sunset Rooibos",
    ],
  },
  {
    id: 7,
    name: "Brewed Calm",
    category: "Tisanes",
    price: "6.10",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.webp",
    images: ["/img/107.webp", "/img/107a.webp", "/img/107b.webp", "/img/107c.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "Egyptian chamomile, Egyptian mint, South African rooibos, safflower petals, flavoring",
    description: [
      "A caffeine-free blend of cooling mint, calming chamomile, and juicy orange rooibos!",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Tisane+ | sweet, slightly tart, fresh orange, velvety",
      "Tisane Tips: A caffeine-free, stomach-settling (low in tannin), cooling, sleepy-time tea.",
      "Ingredients: Egyptian chamomile, Egyptian mint, South African rooibos, safflower petals, flavoring",
      "How to Steep: 2 heaping tsp, 8 oz water, 212°F, 5–8 min",
      "Fun Fact: Chamomile and mint were used medicinally in ancient Greece and Egypt.",
    ],
  },
  {
    id: 8,
    name: "Jasmine Pearls",
    category: "Teas",
    price: "8.10",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.webp",
    images: ["/img/108.webp", "/img/108a.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "China, Fujian Province green tea, scented with jasmine blossoms",
    description: [
      "A fragrant tea made by skilled artisans who scent the green tea leaves with jasmine blossoms and shape the pearls.",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Green+ | floral, grilled zucchini, medium-body, smooth",
      "Tea Tips: For a mindful experience, use a glass teapot and watch the pearls slowly open.",
      "Ingredients: China, Fujian Province green tea, scented with jasmine blossoms",
      "How to Steep: 1 heaping tsp, 8 oz water, 175°F, drink after pearls fully open. Steep tea leaves a second time.",
      "Fun Fact: The best time to harvest jasmine blossoms is during the early morning, when the flowers are still tightly closed.",
      "Similar Teas: Jasmine Silver Tips, Snow Jasmine",
    ],
  },
  {
    id: 9,
    name: "Paris Morning Tea",
    category: "Teas",
    price: "10.10",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp", "/img/109a.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "Organic Indian black tea, Darjeeling 1st Flush, organic flavorings",
    description: [
      "This tea captures the flavors of Paris, with notes of buttery croissant, candied tangerine, and floral honey!",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Black+ | fruity, sweet citrus, vanilla, buttery brioche",
      "Tea Tips: Delicious with or without milk and sugar. Pair with any pastry or dessert.",
      "Ingredients: Organic Indian black tea, Darjeeling 1st Flush, organic flavorings",
      "How to Steep: 1 tsp, 8 oz water, 212°F, 4–5 min",
      "Fun Fact: Who says the British have a patent on breakfast teas? Paris Breakfast is a departure from bold English Breakfast tea blends and is delicious with or without milk and sugar.",
      "Similar Teas: Morning Moment, French Breakfast Tea, Classic Breakfast Tea",
      "Our organic ingredients are selected from suppliers that document origin, handling, and applicable purity standards.",
    ],
  },
  {
    id: 10,
    name: "Vanilla Cream Earl Grey",
    category: "Teas",
    price: "6.70",
    reviews: "312",
    rating: "4.8",
    image: "/img/1010.webp",
    images: ["/img/1010.webp", "/img/1010a.webp"],
    size: ["1 oz", "2 oz", "4 oz", "8 oz", "16 oz"],
    colors: ["Tin", "Teabags", "Loose Leaf"],
    material: "China black tea, blue cornflowers, natural flavoring",
    description: [
      "Vanilla Cream Earl Grey combines floral citrus bergamot with smooth vanilla for a silky, flavorful cup.",
    ],
    Features: [
      "Tea Type or Tisane | Flavors: Black+ | creamy, citrus, floral, vanilla, velvety",
      "Tea Tips: Delicious with or without milk or sugar, this tea has a silky mouthfeel and is a great P.M. pick-me-up.",
      "Ingredients: China black tea, blue cornflowers, natural flavoring",
      "How to Steep: 1 tsp, 8 oz water, 212°F, 4–5 min",
      "Fun Fact: Earl Grey is flavored with oil from the peel of the bergamot citrus fruit and is named after 2nd Earl Grey, who was Prime Minister of the United Kingdom from 1830 to 1834.",
      "Similar Teas: Blue Bergamot Earl Grey, Classic Earl Grey, Russian Breakfast Tea",
    ],
  },
  {
    id: 11,
    name: "Costa Rica Viennese",
    category: "Coffee",
    price: "7.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp", "/img/1011a.jpg", "/img/1011b.webp"],
    size: ["8 oz", "16 oz"],
    colors: ["Whole Bean", "Drip (Med)", "French Press", "Espresso"],
    material: "Costa Rica arabica coffee beans",
    description: [
      "This carefully developed Viennese roast preserves the coffee's layered character while adding a rich note of dark toffee.",
      "Comes in 8 or 16 oz bags. Please specify whole bean or preferred grind. Brewing directions are on each bag. NOTE: If grind is not selected, we will Drip (Med) grind the coffees.",
    ],
    Features: [
      "Roast | Body | Flavors: Viennese roast | medium-full body | orange blossom, black currant, dark toffee",
      "Coffee Tips: A versatile coffee that works especially well in a French press or as espresso.",
      "Fun Fact: The mineral-rich soils of Costa Rica's highlands help coffees develop bright aromatics and deep sweetness.",
      "Ingredients: Costa Rica arabica coffee beans",
      "Similar Coffees: Central Square Blend, Bold City Roast, Wake-Up Blend",
    ],
  },
  {
    id: 12,
    name: "Bold City Roast",
    category: "Coffee",
    price: "6.70",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp"],
    size: ["8 oz", "16 oz"],
    colors: ["Whole Bean", "Drip (Med)", "French Press", "Espresso"],
    material: "100% Arabica coffee beans from Guatemala and Colombia",
    description: [
      "This coffee is carefully roasted for the bold character of a dark roast while preserving the lively first sip usually associated with lighter roasts.",
      "Note: in November 2024 this blend was upgraded to a new blend that features a bit more complexity and a more enjoyable finish.",
      "Comes in 8 or 16 oz. Please specify whole bean or preferred grind. Brewing directions are on each bag.",
    ],
    Features: [
      "Roast | Body | Flavors: dark-medium roast+ | full-body | early brightness, cocoa, hint of nuts, slight smokiness",
      "Coffee Tips: A coffee to fuel your day. Delicious with or without milk and sugar.",
      "Fun Fact: Blending coffees before roasting can balance bright top notes with a deep, smoky finish.",
      "Ingredients:100% Arabica coffee beans from Guatemala and Colombia",
      "Similar Coffees: Central Square Blend, Costa Rica Viennese",
    ],
  },
  {
    id: 13,
    name: "Central Square Blend",
    category: "Coffee",
    price: "6.40",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp"],
    size: ["8 oz", "16 oz"],
    colors: ["Whole Bean", "Drip (Med)", "French Press", "Espresso"],
    material: "Uganda, Brazil, Colombia arabica coffee beans",
    description: [
      "This full-bodied, complex blend combines complementary coffees for dark cocoa, berry, and oak notes. Equally delicious for drip or espresso.",
      "Comes in 8 or 16 oz. Please specify whole bean or preferred grind. Brewing directions are on each bag.",
    ],
    Features: [
      "Roast | Body | Flavors: med/dark roast | full-body | dark cocoa, blackberry, oaky sweetness",
      "Coffee Tips: Customers love this coffee drip, French press, or as an espresso.",
      "Fun Fact: A multi-origin blend lets a roaster balance body, aroma, sweetness, and finish in one cup.",
      "Ingredients:  Uganda, Brazil, Colombia arabica coffee beans",
      "Similar Coffees: Bold City Roast, Costa Rica Viennese",
    ],
  },
  {
    id: 14,
    name: "Wake-Up Blend",
    category: "Coffee",
    price: "6.40",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp", "/img/1014a.webp", "/img/1014b.webp"],
    size: ["8 oz", "16 oz"],
    colors: ["Whole Bean", "Drip (Med)", "French Press", "Espresso"],
    material: "Costa Rica arabica dark roast coffee beans, flavoring",
    description: [
      "A customer favorite for three decades, this light and dark roasted coffee blend has a whisper of vanilla. This coffee will make you want to wake up!",
      "Comes in 8 or 16 oz. Please specify whole bean or preferred grind. Brewing directions are on each bag. NOTE: If grind is not selected, we will Drip (Med) grind the coffees.",
    ],
    Features: [
      "Roast | Body | Flavors: Medium roast+ | full-body | dark cocoa, creamy, light vanilla, lingering flavor",
      "Coffee Tips: Delicious with or without milk and sugar. Also a coffee for a midday boost.",
      "Ingredients: Costa Rica arabica dark roast coffee beans, flavoring",
      "Fun Fact: The word \"coffee\" became part of the English language in 1582. The word was borrowed from the Dutch word koffie, which was borrowed from the Turkish word kahve, which was borrowed from the Yemini word qahwah.",
    ],
  },
  {
    id: 15,
    name: "Holiday Blend",
    category: "Coffee",
    price: "6.40",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.webp",
    images: ["/img/1015.webp", "/img/1015a.webp", "/img/1015b.webp"],
    size: ["8 oz", "16 oz"],
    colors: ["Whole Bean", "Drip (Med)", "French Press", "Espresso"],
    material: "Arabica coffee beans, cinnamon, natural flavoring",
    description: [
      "Holiday Blend's magical mixture of hazelnut and cinnamon will welcome your family and friends before, during, and after the holidays.",
      "Comes in 8 or 16 oz. Please specify whole bean or preferred grind. Brewing directions are on each bag. NOTE: If grind is not selected, we will Drip (Med) grind the coffees.",
    ],
    Features: [
      "Roast | Body | Flavors: medium roast+ | medium-body | toasted hazelnut , dark chocolate, warm spices",
      "Coffee Tips: A dessert coffee. Delicious with or without milk and sugar.",
      "Fun Fact: The term \"cup of Joe\" comes from World War II U.S. servicemen (GI Joes), who were big coffee drinkers.",
      "Ingredients:Arabica coffee beans, cinnamon, natural flavoring Note: No hazelnuts or other nuts are used in this coffee blend.",
      "Similar Coffees: Dark Chocolate Roast, Spiced Mountain Blend, Hazelnut Cream Coffee",
    ],
  },
  {
    id: 16,
    name: "Central Square Blend Reserve",
    category: "Coffee",
    price: "6.40",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp"],
    size: ["8 oz", "16 oz"],
    colors: ["Whole Bean", "Drip (Med)", "French Press", "Espresso"],
    material: "Uganda, Brazil, Colombia arabica coffee beans",
    description: [
      "A full-bodied reserve blend that layers dark cocoa, blackberry, and subtle oak sweetness. Equally delicious for drip or espresso.",
      "Comes in 8 or 16 oz. Please specify whole bean or preferred grind. Brewing directions are on each bag.",
    ],
    Features: [
      "Roast | Body | Flavors: med/dark roast | full-body | dark cocoa, blackberry, oaky sweetness",
      "Coffee Tips: Customers love this coffee drip, French press, or as an espresso.",
      "Fun Fact: Small adjustments to origin proportions can bring out a blend's sweetness without sacrificing body.",
      "Ingredients:  Uganda, Brazil, Colombia arabica coffee beans",
      "Similar Coffees: Bold City Roast, Costa Rica Viennese",
    ],
  },
  {
    id: 17,
    name: "Make-Your-Own Teabags with Drawstrings",
    category: "Accessories",
    price: "12.95",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp", "/img/1017a.webp", "/img/1017b.webp", "/img/1017c.webp"],
    size: ["50 Count"],
    colors: ["Unbleached"],
    material: "Biodegradable paper",
    description: [
      "These teabags are great for making a single cup of tea at home, work, or while traveling!",
      "Product Details: Made in Germany, these unbleached tea bags are biodegradable and have a convenient drawstring for securing your tea inside. The box contains 50 disposable teabags.",
    ],
    Features: [
      "Fun Fact: American Thomas Sullivan invented the teabag when he sent out samples in small silk pouches to customers in1904.",
      "Product Details: Unbleached and biodegradable. Use these filters to make one cup of tea.",
    ],
  },
  {
    id: 18,
    name: "Make-Your-Own Teabags, Small",
    category: "Accessories",
    price: "7.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.webp",
    images: ["/img/1018.webp", "/img/1018a.webp"],
    size: ["100 Count"],
    colors: ["Unbleached"],
    material: "Biodegradable paper",
    description: [
      "These teabags are great for making a single cup of tea at home, work, or while traveling!",
      "Product Details: Made in Germany, these unbleached tea bags are biodegradable. The box contains 100 disposable teabags.",
    ],
    Features: [
      "Fun Fact: American Thomas Sullivan invented the teabag when he sent out samples in small silk pouches to customers in 1904.",
      "Product Details: Unbleached and biodegradable. Use these filters to make one cup of tea.",
    ],
  },
  {
    id: 19,
    name: "Tea Measuring Spoon",
    category: "Accessories",
    price: "6.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    size: ["5\" Length"],
    colors: ["Stainless Steel"],
    material: "18/8 Stainless Steel",
    description: [
      "Our tea measuring spoon helps ensure that every cup of tea is just the way you like it.",
      "Product Details: When leveled with tea, the spoon holds approximately 1 tsp. Overall length with the handle is 5\". Made from dishwasher-safe, 18/8 stainless steel.",
    ],
    Features: [
      "Fun Facts: Fannie Farmer has been called \"The Queen of Level Measurement,\" as she introduced the concept of standardized measuring spoons in her 1896 work The Boston Cooking-School Cook Book. It was one of the first cookbooks to use precise measurements in recipes, for which she was both widely acclaimed and criticized.",
    ],
  },
  {
    id: 20,
    name: "Teacup, Double-Walled Glass, 4 oz",
    category: "Accessories",
    price: "7.95",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp", "/img/1020a.webp"],
    size: ["1 pc", "Set of 4"],
    colors: ["Clear"],
    material: "Tempered Glass",
    description: [
      "See the beauty of your brew with these glass cups—available individually or as a set of four. The double-walled cup keeps your brew hot and your hands cool.",
      "Product Details These cups are made from tempered glass and hold approximately 4 oz of liquid. Dishwasher-safe.",
    ],
    Features: [
      "Fun Facts: The vacuum seal in the glass keeps your hands safe from the heat and also keeps condensation out.",
    ],
  },
  {
    id: 21,
    name: "Bamboo Whisk",
    category: "Accessories",
    price: "19.95",
    reviews: "0",
    rating: "4.5",
    image: "/img/1021.webp",
    images: ["/img/1021.webp", "/img/1021a.webp", "/img/1021b.webp"],
    size: ["4.25\" Height"],
    colors: ["Natural Bamboo"],
    material: "One Piece Natural Bamboo",
    description: [
      "Skillfully handmade from one piece of natural bamboo, the matcha whisk (chasen) is used to whisk matcha into a frothy foam.",
      "Product Details: One piece of bamboo is cut into dozens of thin tines. The soft, flexible tines prevent scratches in your tea bowl. Height: 4.25\"",
    ],
    Features: [
      "Matcha-Making Tips: Before whisking the matcha, which is considered an art form, soak the tines in hot water to soften them (this prevents breakage of the tines). Pour a small amount of hot water into the bowl, and use the bamboo scoop to blend the water and matcha into a thick paste. Add the rest of the hot water and whisk the mixture briskly until a consistent bubbly foam covers the surface of the vessel.",
    ],
  },
  {
    id: 22,
    name: "Auto Tea Steeper",
    category: "Accessories",
    price: "48.95",
    reviews: "0",
    rating: "4.7",
    image: "/img/1022.webp",
    images: ["/img/1022.webp", "/img/1022a.webp", "/img/1022b.webp", "/img/1022c.webp", "/img/1022d.webp"],
    size: ["L 7.5\" x W 5.5\" x H 8.0\""],
    colors: ["White Porcelain"],
    material: "Porcelain",
    description: [
      "This clever device makes tea-making simple! Put the recommended amount of tea into the top, pour in hot water, and walk away. No timer needed—genius!",
      "Product Details: Product dimensions and weight: L 7.5\" x W 5.5\" x H 8.0\"",
    ],
    Features: [
      "The porcelain teapot makes 14 oz of tea and is dishwasher-safe, but we recommend hand-washing the top chamber. A small hole in the infuser allows the tea to slowly drip through and ensures perfect steeping of the leaves.",
    ],
  },
];

const safeProductData = productData.map((product) => ({
  ...product,
  image: product.image.replace(/\.(?:webp|jpg)$/i, ".jpg"),
  images: product.images.map((image) =>
    image.replace(/\.(?:webp|jpg)$/i, ".jpg")
  ),
}));

export default safeProductData;
